import { useTrackingManager } from '../TrackingManagerContext.js';
import getDefaultTrackingPreference from '../utils/getDefaultTrackingPreference.js';
import useSavedTrackingPreference from './useSavedTrackingPreference.js';
const useTrackingPreference = () => {
  const preference = useSavedTrackingPreference();
  const _useTrackingManager = useTrackingManager(),
    region = _useTrackingManager.region,
    config = _useTrackingManager.config;
  if (!preference) return getDefaultTrackingPreference(region, config);
  return preference;
};
export { useTrackingPreference as default };
//# sourceMappingURL=useTrackingPreference.js.map
